export default __webpack_public_path__ + "assets/models/a78dbfe3bb17b9593763af60aa4cff8f.glb";